import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { sec } from "../../../security";

const apiServerUrl = process.env.REACT_APP_HAISTACK_API_URL;

export const languageApi = createApi({
  reducerPath: "language",
  tagTypes: ["Languages"],
  baseQuery: fetchBaseQuery({
    baseUrl: apiServerUrl,
    prepareHeaders: async (headers) => {
      const token = await sec.getAccessTokenSilently()();

      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }

      return headers;
    }
  }),
  endpoints: (builder) => ({
    getLanguages: builder.query({
      query: () => "api/v2/languages",
      transformResponse: (response: any) => {
        return response.languages;
      }
    })
  })
});

export const { useGetLanguagesQuery } = languageApi;
